/**
 * external dependencies
 */
import { TabulatorFull, Options, CellComponent } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { IPinPoolIndivdiual } from '../../../../../models/cardgroup.interface';
import { tableSearchInput } from '../../../../Tables/table-helpers';
import { removePin } from '../remove/remove-pin';


export const pinPoolTable = (data: IPinPoolIndivdiual[], askFor: number) => {
  const tableContainer = document.querySelector('.aafp_pin-pool-list') as HTMLElement;
  if (!tableContainer) return;

  const edit_cellclick = (e: any, cell: CellComponent) => {
    const currentRow = cell.getData() as IPinPoolIndivdiual;
    removePin(currentRow, askFor);
  }

  const edit_button = (cell: CellComponent, formatterParams: any) => {
    const { validValue, description } = cell.getData() as IPinPoolIndivdiual;
    return `<a role="button" 
                id="aag_edit-personnel_${validValue}" 
                class="aafp_btn-table btn_theme-warning" 
                data-toggle="tooltip"
                data-placement="bottom" 
                title="Delete ${description}">
              <i class="far fa-trash-alt"></i>
            </a>`;
  }


  const options: Options = {
    data,
    layout: "fitDataFill",
    placeholder: "No Data Available",
    placeholderHeaderFilter: "No Matching Data",
    pagination:true,
    paginationMode: "local",
    paginationSize: 10,
    paginationSizeSelector: [25, 50, 100],
    paginationCounter: "rows",
    layoutColumnsOnNewData:true,
    minHeight: "560px",
    selectableRows: false,
    columns: [
      { title: "PIN", field: "validValue", sorter: 'string', resizable: false, vertAlign: 'middle', width: 200 },
      { title: "Description", field: "description", sorter: 'string', resizable: false, vertAlign: 'middle', width: 650 },
      { title: '', field: "EditButton", formatter: edit_button, hozAlign: 'center', width: 40, cellClick: edit_cellclick, headerSort: false, resizable: false }
    ]
  };

  const pinPoolTable = new TabulatorFull(tableContainer, options);
  const taxListSort = document.querySelector('#aafp_tax-list-sort') as HTMLInputElement;
  taxListSort.classList.remove('aafp_display-none');
  tableSearchInput(taxListSort, pinPoolTable);

  return pinPoolTable;
}